import { AgmCoreModule } from '@agm/core';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import {GestureConfig, MatDatepickerModule, MatDialogModule, MatProgressBarModule} from '@angular/material';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaxNgLibModule } from 'max-ng-lib';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  ClassInitService,
  MenuConfigService,
  PageConfigService,
  SplashScreenService,
  SubheaderService,
  UtilsService,
} from './content/layout/services';
import { HeaderService } from './content/layout/services/header.service';
import { MenuAsideService } from './content/layout/services/menu-aside.service';
import { MenuHorizontalService } from './content/layout/services/menu-horizontal.service';
import { VoltarAoTopoService } from './content/pages/components/shared/components/voltar-ao-topo/volta-ao-topo.service';
import { VoltarAoTopoModule } from './content/pages/components/shared/components/voltar-ao-topo/voltar-ao-topo.module';
import { ErrorPageComponent } from './content/pages/error-page/error-page.component';
import { IndexedDbModel } from './content/pages/models/indexed-db.model';
import { AuthGuard, HttpsRequestInterceptorService } from './core/auth';
import {NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule} from '@angular-material-components/datetime-picker';
import {
  DialogFormularioPesquisaModule
} from './core/shared-components/dialog-formulario-pesquisa/dialog-formulario-pesquisa.module';
import {
  DialogPopupRodizioVeiculoModule
} from './core/shared-components/dialog-popup-info-rodizio-veiculo/dialog-popup-rodizio-veiculo.module';

registerLocaleData(localePt, 'pt');

const dbConfig: DBConfig = {
  name: 'RoteirizadorDb',
  version: 1,
  objectStoresMeta: [{
    store: 'roteirizacao_filtroRoteirizacao',
    storeConfig: {keyPath: 'id', autoIncrement: true},
    storeSchema: []
  }, {
    store: 'roteirizacao_filtroRoteirizacao',
    storeConfig: {keyPath: 'id', autoIncrement: true},
    storeSchema: []
  }, {
    store: 'roteirizacao_listaPreCargas',
    storeConfig: {keyPath: 'id', autoIncrement: true},
    storeSchema: []
  },
  {
    store: 'roteirizacao_ordemGridPreCarga',
    storeConfig: {keyPath: 'id', autoIncrement: true},
    storeSchema: []
  },
  {
    store: 'filtros_distribuicaoAutomatica',
    storeConfig: {keyPath: 'id', autoIncrement: true},
    storeSchema: []
  },
]
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  // suppressScrollX: true
};
@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    HttpClientModule,
    MatProgressBarModule,
    MaxNgLibModule,
    AgmCoreModule.forRoot(
    {
      apiKey: environment.CHAVE_GOOGLE_MAPS,
      libraries: ['drawing'],
      language: 'pt',
      apiVersion: '3.64'
    }),
    NgxIndexedDBModule.forRoot(IndexedDbModel.DB_CONFIG),
    AppRoutingModule,
    VoltarAoTopoModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    DialogFormularioPesquisaModule,
    DialogPopupRodizioVeiculoModule
  ],
  providers: [
    AuthGuard,
    MenuConfigService,
    PageConfigService,
    UtilsService,
    SubheaderService,
    HeaderService,
    ClassInitService,
    MenuHorizontalService,
    SplashScreenService,
    VoltarAoTopoService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    MenuAsideService,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: GestureConfig
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptorService,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
